<template>
  <div class="view-req-detail" style="background:transparent;margin-bottom: 100px" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div>
          <ul class="relative request_detail_ul">
            <!--            *****************************-->
            <li>
              <label>{{ $t('requestNameQ') }}</label>
              <span>
                  {{ request_info.RequestCode }}
              </span>
            </li>
            <hr>
            <li>
              <label>{{ $t('requestNameQ') }}</label>
              <span>
                  {{ request_info.RequestName }}
              </span>
            </li>
            <hr>
            <li>
              <label>توضیحات داخلی:</label>
              <span>
                  {{ request_info.SummaryLocal }}
              </span>
            </li>
            <hr>
            <li>
              <label>درخواست های مشترک:</label>
              <span v-for="item in JSON.parse(request_info.OtherReqCode)">
                  {{ item.RequestCode }}
              </span>
            </li>
            <hr>
            <li>
              <label>{{ $t('requestStatusQ') }}</label>
              <span>
                {{ request_info.LastStatus }}
              </span>
            </li>
            <hr>

            <!--            *****************************-->
            <li>
              <label>{{ $t('expertReceiptQ') }}</label>

              <span>
                {{ request_info.ExpertName }}
              </span>
            </li>
            <hr>

            <li>
              <label>{{ $t('devicePasswordQ') }}</label>
              <span>
                {{ request_info.DevicePass }}
              </span>
            </li>
            <hr>

            <li>
              <label>{{ $t('appearanceProblemQ') }}</label>
              <span>
                {{ request_info.AppearanceProblem }}
              </span>
            </li>
            <hr>

            <li>
              <label>{{ $t('phoneNoQ') }}</label>

              <span>
                {{ request_info.CustomerMobile }}
              </span>
            </li>
            <hr>

            <li>
              <label>{{ $t('ExpertOpinionQ') }}</label>
              <span>
                {{ request_info.ExpertOpinion }}
              </span>
            </li>
            <hr>
            <li>
              <label>{{ $t('predefinedTagsQ') }}</label>
              <div class="text-right">
                <v-chip v-for="item in request_info.PredefinedGlobal"
                        class="ma-1"
                        color="primary"
                >
                  {{ item.Text }}:{{ item.Value }}
                </v-chip>

                <v-chip
                  v-for="item in request_info.PredefinedChecked"
                  class="ma-1"
                  color="primary"
                >
                  {{ item.Text }}:{{ item.Value }}

                </v-chip>
              </div>
            </li>
            <hr>
            <li v-if="request_info.EjraiStatusSummary!=null">
              <label>{{ $t('referDescriptionQ') }}</label>

              <div v-for="ejraii in JSON.parse(request_info.EjraiStatusSummary)">
                {{ ejraii.StatusName }} : {{ ejraii.Summary }}
              </div>

            </li>
            <hr>
            <li>
              <label>{{ $t('priceRangeQ') }}</label>

              <span>
               {{ request_info.TechPriceRange }}
              </span>
            </li>

            <hr>

            <li>
              <label>{{ $t('summary') }}:</label>

              <span>
               {{ request_info.Summary }}
              </span>
            </li>
<li>
  <v-row>

    <v-col cols="12" class="pa-1">
      <label>{{ $t('addressesQ') }}</label>
      <div v-for="item in request_info.Addresses">
        <div class="addresses">
                  <span>
                    {{ item.CityName }} - {{ item.AreaName }} {{ item.AddressText }}
                  </span>
        </div>
        <div class="pt-3 text-center">

          <v-btn

            v-if="item.Lat !=null"
            class="ml-2"
            outlined
            rounded
            color="primary"
            v-on:click="go_direction(item,1)"
          >{{ $t('navigation') }}
          </v-btn>
          <v-btn

            v-if="item.Lat !=null"
            class="ml-2"
            outlined
            rounded
            color="primary"
            v-on:click="go_direction(item,3)"
          >مسیریابی نشان</v-btn>
          <v-btn

            v-if="item.Lat !=null"
            class="ml-2"
            outlined
            rounded
            color="primary"
            v-on:click="go_direction(item,2)"
          >مسیریابی ویز</v-btn>

        </div>
      </div>

    </v-col>
    <v-col cols="12" class="pa-1">
      <label>آخرین وضعیت</label>
      <div class="addresses">
                  <span>
                    {{ request_info.LastTechStatus }}
                  </span>
      </div>
    </v-col>

  </v-row>

</li>
          </ul>


        </div>
        <div>
          <v-row>
            <v-col>
              <v-btn color="primary" v-if="action_button_text != ''" v-on:click="go_to_categories()">
                {{ action_button_text }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <a :href="'tel:'+request_info.CustomerMobile" class="width-100-p " color="primary" style="background: #0a67ff;color: white;width: 100%;text-align: center"  v-if="action_button_text != ''">{{ $t('callToCustomer') }}
              </a>
            </v-col>
          </v-row>
          <v-row  v-if="request_info.StatusId==15">
            <v-col cols="12">
                <v-btn v-on:click="change_predefined()" class="width-100-p" color="primary">
                  تغییر لوازم همراه
                </v-btn>
            </v-col>
            <v-col cols="12" >
                <v-btn v-on:click="change_request_status(17)" class="width-100-p" color="primary">
                  تایید دریافت از مشتری
                </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="request_info.StatusId == request_statuses[5] || request_info.StatusId == request_statuses[16]">
            <v-col cols="12">
              <v-btn class="width-100-p" @click="tickets_dialog=true" color="primary">
                {{ $t('tickets') }}
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn class="width-100-p" color="primary">
                {{ $t('preFactors') }}
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn class="width-100-p" color="primary"
                     v-on:click="go_to_goods_factors()">{{ $t('productRequests') }}
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn class="width-100-p" color="primary"
                     v-on:click="go_to_informher_masters()">{{ $t('customerInformHer') }}
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn v-on:click="change_status_dialog=true" class="width-100-p" color="primary">{{
                  $t('changeStatusRequest')
                }}
              </v-btn>
            </v-col>


            <v-col cols="12">
              <v-btn v-on:click="go_to_qc()" class="width-100-p" color="primary">{{ $t('qc') }}</v-btn>
            </v-col>

          </v-row>
        </div>
      </div>



    </div>
    <div >
      <v-dialog
        v-model="change_status_dialog"
        max-width="290"
        :retain-focus="false"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">
            {{ $t('changeStatusRequest') }}
          </v-card-title>
          <v-card-text>
            <v-row class="relative">
              <v-col cols="12">
                <v-select
                  :items="status_list_items"
                  :label="$t('NewStatusChangeStatus')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_status_for_change"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row class="relative">
              <v-col cols="12">
                <v-textarea
                  rows="2"
                  v-model="change_status_summary" :placeholder="$t('insertChangeStatusSummary')"/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="change_status_dialog = false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              v-if="selected_status_for_change != 0"
              class="accept-btn"
              text
              @click="change_tech_status()"
            >
              {{ $t('ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div >
      <v-dialog
        v-model="dialog_accept_refer"
        max-width="290"
        fullscreen
        v-if="dialog_accept_refer"

        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">
            هشدار
          </v-card-title>
          <v-card-text>
            <v-row class="relative">
              <v-col cols="12">
                آیا ارجاع این درخواست را تایید میکنید؟
                <v-text-field
                  v-model="req_tech_refer_summary"
                  placeholder="توضیحات"
                />
              </v-col>
            </v-row>
            <v-row class="relative">

            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-row>
              <v-col cols="6">
                <v-btn
                  class="accept-btn"
                  text
                  style="width: 100%"

                  @click="accept_refer_tech(1)"
                >
                  دریافت درخواست ارجاعی
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  class="accept-btn"
                  text
                  style="width: 100%"
                  @click="accept_refer_tech(0)"
                >
                  رد درخواست ارجاعی
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="cancle-btn"
                  text
                  style="width: 100%"

                  @click="dialog_accept_refer = false,$router.go(-1)"
                >
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>
            </v-row>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog
      v-model="tickets_dialog"
      max-width="290"
      fullscreen
      hide-overlay
    >

      <v-card class="category-modal">
        <v-card-title class="headline">
          {{ $t('tickets') }}
        </v-card-title>
        <v-card-text>
          <v-row class="relative">
            <v-col cols="12">
              <div v-for="(ticket,index) in request_info.Tickets" :key="'ticket'+index">
                {{ ticket }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>

          <v-btn
            class="accept-btn"
            text
            @click="tickets_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="returned_request"
      v-model="returned_request"
      max-width="290"
      :retain-focus="false"
      persistent
      fullscreen
    >

      <v-card class="category-modal">
        <v-card-title class="headline">
          هشدار
        </v-card-title>
        <v-card-text>
          <v-row class="relative">
            <v-col cols="12">
              کاربر گرامی لطفا قبل از تایید دریافت، اقلام دستگاه مرجوعی را از منو تغییر اقلام همراه اعلام کنید، در غیر این صورت عواقب آن بر عهده شما می باشد
            </v-col>
          </v-row>
          <v-row class="relative">

          </v-row>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="6">
              <v-btn
                class="accept-btn"
                text
                style="width: 100%"

                @click="returned_request=false"
              >
                تایید
              </v-btn>
            </v-col>

          </v-row>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {bus} from '../../main.js'

export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      returned_request:false,
      change_status_summary: '',
      dialog_accept_refer: false,
      change_status_dialog: false,
      tickets_dialog: false,
      req_tech_refer_summary: "",
      status_list_items: [],
      selected_status_for_change: 0,
      errors: [],
      request_info: [],
      action_button_text: '',
      request_statuses: [],
      next_action_status: 0,
      branch_id: 0,

      technician_name: 'hamid mokhtari',
      device_password: 'hamid mokhtari',
      current_lat: '',
      current_lng: '',
      source_location_lat: '',
      source_location_lng: '',

    }
  },
  watch: {
    selected_province: function () {
      this.get_cities()
    }
  },
  mounted() {
    this.get_current_location()
    // var passing_data = JSON.parse(localStorage.getItem('request_data'));
    // this.enable_send_from_country = passing_data.on_site_service;
    // this.get_phone_prefix()
    // this.get_device_status()
    // this.get_provinces()
    this.get_stats_list()
    this.get_request_info()
    this.get_branch_permission()
  },
  methods: {
    change_predefined(){
this.$router.push({path:'/report-request/changed-predined-return/'+this.$route.params.rec_id})
    },
    go_direction(item,state) {
      // var url = 'geo:0,0?q=' + item.Lat + ',' + item.Lng
      // var url = 'https://www.google.com/maps/@' + item.Lat + ','+item.Lng+',17z'
      // var url = 'https://www.google.co.in/maps/dir/?saddr=&daddr=' + item.Lat + ',' + item.Lng + '&directionsmode=driving'
      var url = ""
      if(state==1){
         url = `https://maps.google.com/?q=${item.Lat},${item.Lng}`

      }
      if(state==2){
         url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`

      }
      if(state==3){
        url = `https://nshn.ir/?lat=${item.Lat}&lng=${item.Lng}`
      }

      // window.open(url, '_blank')
      window.open(url, '_blank')
    },
    get_request_info() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        ExpertId: user_id,
        RequestId: this.$route.params.rec_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetRequestInfoByReqId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.request_info = response.data.rec
            console.log("refer accept is", self.request_info.AcceptRefer)
            if (self.request_info.AcceptRefer == "0") {
              bus.$emit('show_toast', [3000, 'ارجاع درخواست توسط شما رد شده است'])
              self.$router.go(-1);
            }
            if (self.request_info.AcceptRefer == "10") {
              self.dialog_accept_refer = true;
            }
            if(self.request_info.StatusId==12 && !self.dialog_accept_refer){

              self.returned_request = true;
            }
            this.get_device_status()
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        this.errors.push(e)
      })
    },
    accept_refer_tech(status) {
      if (status == 0 && this.req_tech_refer_summary == "") {
        bus.$emit('show_toast', [2000, "توضیحات را وارد کنید"])
        return
      }
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ProcessId: this.$route.params.rec_id,
        RecStatusId: this.request_info.RecStatusId,
        ProcessType: 1,
        ItemDesc: this.req_tech_refer_summary,
        AcceptType: status,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddProcessReferAccept', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.get_request_info()
            self.dialog_accept_refer = false;
            if (status == 0) {
              self.$router.go(-1)
            }
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_stats_list() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        ExpertId: user_id,
        RequestId: this.$route.params.rec_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetStatusListForTech', send_data, {})
        .then(response => {
          response.data.StatusList.forEach(function (number) {
            var obj = {value: number.Id, label: number.StateName}
            self.status_list_items.push(obj)
          })
          self.selected_status_for_change = self.status_list_items[0].value;

        }).catch(e => {
        this.errors.push(e)
      })
    },
    add_informher_master() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        RequestId: this.$route.params.rec_id,
        ReqName: this.request_info.RequestName,
        BranchId: this.branch_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddMasterFacator', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.get_informher_master()
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        this.errors.push(e)
      })
    },
    change_tech_status() {
      var self = this;
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        StatusId: this.selected_status_for_change,
        Desc: this.change_status_summary,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddChangeStatusByTech', send_data, {})
        .then(response => {
          bus.$emit('show_toast', [2000, response.data.msg])
          self.change_status_dialog = false;
          self.selected_status_for_change=self.status_list_items[0].value
          self.change_status_summary =""
          self.get_request_info()
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        this.errors.push(e)
      })
    },
    go_to_categories() {
      var self = this
      if (self.request_info.StatusId == self.request_statuses[2]) {
        self.action_button_text = self.$t('startToDelivery')
        self.next_action_status = self.request_statuses[3]
        self.get_last_user_location(this.next_action_status)

        return
      } else if (self.request_info.StatusId == self.request_statuses[3]) {
        self.action_button_text = self.$t('giveToCustomer')
        self.next_action_status = self.request_statuses[4]
      } else if (self.request_info.StatusId == self.request_statuses[4]) {
        self.action_button_text = ''
        self.next_action_status = 0
      } else if (self.request_info.StatusId == self.request_statuses[5]) {
        self.action_button_text = ''
        self.next_action_status = 0
      } else {
        self.action_button_text = ''
        self.next_action_status = 0
      }
      self.change_request_status(this.next_action_status)
    },
    go_to_goods_factors() {
      var self = this
      var passing_data = {
        category: 3,
        user: null,
        request: self.$route.params.rec_id,
        branch: this.branch_id,
        summary: "",
      }
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // passing_data.cat_id = item_id;
      localStorage.setItem("request_product", JSON.stringify(passing_data));
      console.log(passing_data)
      // this.dialog_factor = false
      this.$router.push({name: 'ProductRequestFactors', params: {rec_id: this.$route.params.rec_id}})
      // var self = this
      // self.$router.push({ path: '/report-request/request-goods-factors/' + self.$route.params.rec_id })
    },
    go_to_qc() {

      this.$router.push({name: 'RequestQualityControl', params: {rec_id: this.$route.params.rec_id}})
    },
    go_to_informher_masters() {
      this.$router.push({path: '/report-request/inform-her-masters/' + this.$route.params.rec_id})
    },
    get_device_status() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      console.log()
      const send_data = {
        UserId: user_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetStatusSetting', send_data, {})
        .then(response => {
          self.request_statuses = response.data.rslt

          if (self.request_info.StatusId == self.request_statuses[2]) {
            self.action_button_text = self.$t('startToDelivery')
            self.next_action_status = self.request_statuses[3]
          } else if (self.request_info.StatusId == self.request_statuses[3]) {
            self.action_button_text = self.$t('giveToCustomer')
            self.next_action_status = self.request_statuses[4]
          } else if (self.request_info.StatusId == self.request_statuses[4]) {
            self.action_button_text = ''
            self.next_action_status = 0
          } else if (self.request_info.StatusId == self.request_statuses[5]) {
            self.action_button_text = ''
            self.next_action_status = 0
          } else {
            self.action_button_text = ''
            self.next_action_status = 0
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    change_request_status(status_id) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        Desc: '',
        StatusId: status_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ChangeRequestStatus', send_data, {})
        .then(response => {
          self.get_request_info()
          if (status_id == self.request_statuses[4]) {
            // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
            self.$router.push({name: 'signature', params: {rec_id: self.$route.params.rec_id, type_id: 5}})
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ZkGetUserPermission', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_current_location() {
      var self = this

      // This will open permission popup
      navigator.geolocation.getCurrentPosition(function (position) {
        self.current_lat = position.coords.latitude;
        self.current_lng = position.coords.longitude;

      }, function (error) {
        console.log('error location is', error)
      });
    },
    get_last_user_location(status) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        UserId: user_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetLastLocationByUserId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.source_location_lat = response.data.Lat;
            self.source_location_lng = response.data.Lng;
            // this.branch_id = response.data.UserBranchId
          } else {
            self.get_current_location();
            self.source_location_lat = self.current_lat;
            self.source_location_lng = self.current_lng;
          }
          self.get_snapp_price(status);

        }).catch(e => {
        console.log("error", e)
        this.errors.push(e)
      })
    },
    get_snapp_price(status) {
      var self = this

      self.source_location_lat = "35.732846"
      self.source_location_lng = "51.373192"
      if (self.source_location_lat == null || self.source_location_lat == "") {
        bus.$emit('show_toast', [1500, "موقعیت مکانی یافت نشد"])
        // return
      }
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      // const send_data = {
      //   source_lat: self.source_location_lat,
      //   source_lng: self.source_location_lng,
      //   dest_lat: self.request_info.Addresses[0].Lat,
      //   dest_lng: self.request_info.Addresses[0].Lng
      // }
      // console.log("send data snapp", send_data)

      // var config = {
      //   method: 'post',
      //   url: 'https://cp.zoodkomak.com/api/get_user_locations_price',
      //
      //   data: send_data
      // };
      var formData = new FormData();
      formData.append('source_lat', self.source_location_lat);
      formData.append('source_lng', self.source_location_lng);
      formData.append('dest_lat', self.request_info.Addresses[0].Lat);
      formData.append('dest_lng', self.request_info.Addresses[0].Lng);
      // console.log("send data snapp",send_data)
      var url = 'https://cp.zoodkomak.com/api/get_user_locations_price';
      // var config = {
      //   method: 'post',
      //   url: url,
      //
      //   data : send_data
      // };

      this.axios.post(url, formData, {})
        .then(function (response) {
          console.log(response.data.time);
          self.change_request_status_with_price(status, response.data.time, response.data.distance);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    change_request_status_with_price(status_id, price, distance) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        Desc: '',
        ReqType: 1,
        StatusId: status_id,
        SourceLat: self.source_location_lat,
        SourceLng: self.source_location_lng,
        DestLat: self.request_info.Addresses[0].Lat,
        DestLng: self.request_info.Addresses[0].Lng,
        RouteTime: price,
        Distance: distance,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ChangePreRequestStatusWithPrice', send_data, {})
        .then(response => {
          self.get_request_info()
          if (status_id == self.request_statuses[4]) {
            // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
            self.$router.push({name: 'signature', params: {rec_id: self.$route.params.rec_id, type_id: 5}})
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
  }
}
</script>
